
export function massInvitationModalInit() {
  const $modal = $('#mass-invitation-modal')
  if (!$modal.length) return

  // The modal lives inside `pages/show.html.erb` → inside `.portal__panel`,
  // which is a `z-index: 1` stacking context. Bootstrap's `.modal-backdrop`
  // gets appended to `<body>` (outside that context) at `z-index: 1040`.
  // Result: backdrop paints ON TOP of the modal because the modal's internal
  // z:1050 only competes within `.portal__panel`. Teleport the modal to
  // `<body>` before showing so both share the same stacking root.
  $modal.appendTo('body')

  // Bootstrap 4 locks `body { overflow: hidden }` via `.modal-open` but
  // leaves `<html>` scrollable — which means the page still scrolls behind
  // the modal on browsers that scroll the html element. Lock both.
  $('html').addClass('modal-open')
  $modal.on('hidden.bs.modal', () => $('html').removeClass('modal-open'))

  $modal.modal('show')
}